module.exports = __webpack_public_path__ + "img/b5_01.33a0bcd3.jpg";